import Image from "next/image";

import { Paragraph } from "../ui/typography";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";

import { cn } from "@/lib/utils";

export function ProductCardSkeleton({ className, ...props }) {
  return (
    <div className={cn("flex flex-col gap-y-2", className)} {...props}>
      <Skeleton className="w-full aspect-video-course-card-thumbnail" />

      <div className="flex flex-col gap-y-1">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>

      <Skeleton className="h-6 w-32" />

      <Skeleton className="h-9 w-full" />
    </div>
  );
}

function ProductCard({
  product,
  className,
  showPrice = false,
  as = "div",
  ...props
}) {
  // changing the component to the one passed in the as prop
  const Component = as;

  // const showDiscountBadge = product.discountPrice > 0;
  // Debug: showDiscountBadge value available for development

  return (
    <Component
      className={cn(
        "relative flex flex-col gap-y-2 bg-primary-foreground rounded-lg no-underline",
        "border border-grayscale-input p-3 pb-6 h-full",
        className
      )}
      {...props}
    >
      <div className="relative w-full pointer-events-none rounded-lg overflow-hidden mb-2 aspect-video-course-card-thumbnail">
        <Image
          src={product.thumbnailUrl}
          alt={product.title}
          sizes="25rem"
          fill
        />
      </div>

      <Paragraph variant="b4-tight" weight="sb" className="h-8 line-clamp-2">
        {product.title || "No Title"}
      </Paragraph>

      {showPrice && product.discountPrice > 0 && (
        <div className="flex items-center gap-x-1 flex-wrap">
          <Paragraph variant="b3" weight="sb" className="truncate max-w-full">
            ₹{product.discountPrice}
          </Paragraph>
          <Paragraph
            variant="b3-tight"
            className="line-through text-grayscale-placeholder truncate max-w-full"
          >
            ₹{product.basePrice}
          </Paragraph>
        </div>
      )}

      {showPrice && product.freeCourse && (
        <div className="flex h-6">
          <Paragraph variant="b4" weight="sb" className="text-success">
            FREE
          </Paragraph>
        </div>
      )}

      <Button variant="outline" size="small" className="uppercase">
        {product.freeCourse ? "Enroll Now" : "Buy Now"}
      </Button>
    </Component>
  );
}

export default ProductCard;
